import { render, staticRenderFns } from "./ResponsibilityRole.vue?vue&type=template&id=424be909&scoped=true"
import script from "./ResponsibilityRole.vue?vue&type=script&lang=js"
export * from "./ResponsibilityRole.vue?vue&type=script&lang=js"
import style0 from "./ResponsibilityRole.vue?vue&type=style&index=0&id=424be909&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "424be909",
  null
  
)

export default component.exports